import Vue from 'vue'
import Router from 'vue-router'
import PatientList from 'pages/PatientList'
import PatientDetails from 'pages/PatientDetails'

import Tasks from 'pages/Task'
import Users from 'pages/Users'
import Procedures from 'pages/Procedure'
import Medicines from 'pages/Medicines'
import Location from 'pages/Location'
import AddLocation from 'pages/AddLocation'


import PatientReport from 'pages/Report-Patient'
import LocationReport from 'pages/Report-Location'
import HotlineReport from 'pages/Report-Hotline'

import RationLog from 'pages/RationLog'
import RequestForRation from 'pages/RequestForRation'
import TransportRequest from 'pages/TransportRequest'

import TransportVehicle from 'pages/TransportVehicle'
import Distributor from 'pages/RationDistributor'

import Login from 'pages/Login'
import Logout from 'pages/Logout'
import Profile from 'pages/Profile'
// Dashboard

import Dashboard from 'pages/Dashboard'

// forms
import GeneralElements from 'pages/forms/GeneralElements.vue'
import AdvancedElements from 'pages/forms/AdvancedElements.vue'

Vue.use(Router)
const routes = []

export const router = new Router({
  mode: 'history',
  deep: true,
  immediate: true,
  routes: [
    {
      path: '/patients',
      name: 'patient_list',
      component: PatientList
    },
    {
      path: '/patient-details',
      name: 'PatientsDetails',
      component: PatientDetails
    },
    
    {
      path: '/tasks',
      name: 'task_list',
      component: Tasks
    },
   
    {
      path: '/users',
      name: 'user_list',
      component: Users
    },
    
    {
      path: '/procedures',
      name: 'procedures',
      component: Procedures
    },
    {
      path: '/medicines',
      name: 'medicines',
      component: Medicines
    },
    {
      path: '/location',
      name: 'location',
      component: Location
    },
    {
      path: '/patient-report',
      name: 'PatientReport',
      component: PatientReport
    },
    {
      path: '/location-report',
      name: 'LocationReport',
      component: LocationReport
    },
    {
      path: '/hotline-report',
      name: 'HotlineReport',
      component: HotlineReport
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/request',
      name: 'RequestForRation',
      component: RequestForRation
    },
    {
      path: '/ration',
      name: 'RationLog',
      component: RationLog
    },
    {
      path: '/transport',
      name: 'TransportRequest',
      component: TransportRequest
    },
    {
      path: '/distributor',
      name: 'Distributor',
      component: Distributor
    },
    {
      path: '/vehicle',
      name: 'TransportVehicle',
      component: TransportVehicle
    },
    {
      path: '/addlocation',
      name: 'AddLocation',
      component: AddLocation
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    }
  ],
  linkActiveClass: 'active',
  beforeRouteUpdate (to, from, next) {
    this.name = to.params.name
    next()
  }
})
router.beforeEach((to, from, next) => {
  // console.log( localStorage.getItem('users') == null ? 'I AM NULL' : ' I AM NOT NULL ')
  // console.log( localStorage.getItem('users'))
  // console.log('VVVVVVVVVVVVVVVV--->>>>')

  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/forget']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('users') != null ? localStorage.getItem('users') : '{"authorized": false}' 
  const json = JSON.parse( loggedIn )
  const lggged = json.authorized ? json.authorized : false
  if (authRequired && !lggged ) {
    return next('/login')
  }
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js